import { render, staticRenderFns } from "./StudyNewPageUnfinishedDefaultValue.vue?vue&type=template&id=501e532a&scoped=true"
import script from "./StudyNewPageUnfinishedDefaultValue.vue?vue&type=script&lang=js"
export * from "./StudyNewPageUnfinishedDefaultValue.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageUnfinishedDefaultValue.vue?vue&type=style&index=0&id=501e532a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e532a",
  null
  
)

export default component.exports